import { Routes } from '@angular/router';
import { isLogged, isNotLogged } from './cognito/cognito.guard';
import { directionGuard } from './guards/permission-guard';
import { AppPath, AuthPath, BasicPath } from './path';

export const routes: Routes = [{
    canActivate: [isNotLogged],
    path: BasicPath.AUTH,
    children: [
        {
            path: AuthPath.CONFIRM_PASSWORD,
            loadComponent: () => import('./cognito/confirm-password/confirm-password').then(m => m.ConfirmPassword)
        },
        {
            path: AuthPath.FORGOT_PASSWORD,
            loadComponent: () => import('./cognito/forgot-password/forgot-password').then(m => m.ForgotPassword)
        },
        {
            path: AuthPath.LOGIN,
            loadComponent: () => import('./cognito/login/login').then(m => m.Login)
        },
        {
            path: AuthPath.NEW_PASSWORD,
            loadComponent: () => import('./cognito/new-password/new-password').then(m => m.NewPassword)
        },
        {
            path: '**',
            pathMatch: 'full',
            redirectTo: AuthPath.LOGIN
        }
    ]
},
{
    canActivate: [isLogged],
    path: BasicPath.HOME,
    loadComponent: () => import('./routes/layout/layout').then(m => m.Layout),
    children: [
        {
            path: BasicPath.HOME,
            loadComponent: () => import('./routes/home/home').then(m => m.Home)
        },
        {
            path: AppPath.SEARCH_BY_ACCOUNT,
            loadComponent: () => import('./routes/search-by-account/search-by-account').then(m => m.SearchByAccount)
        },
        {
            path: AppPath.UNDERWRITING,
            loadComponent: () => import('./routes/underwriting/underwriting').then(m => m.Underwriting)
        },
        {
            path: AppPath.INSTALLERS,
            loadComponent: () => import('./routes/installers/installers').then(m => m.Installers)
        },
        {
            path: AppPath.CALLS_TO_MAKE,
            loadComponent: () => import('./routes/calls-to-make/calls-to-make').then(m => m.CallsToMake)
        },
        {
            path: AppPath.TICKET,
            loadComponent: () => import('./routes/ticket/ticket').then(m => m.Ticket)
        },
        {
            path: AppPath.TICKET_WITH_ID,
            loadComponent: () => import('./routes/ticket/ticket-readonly').then(m => m.TicketReadonly)
        },
        {
            canActivate: [directionGuard],
            path: AppPath.SCALED_TICKETS,
            loadComponent: () => import('./routes/scaled-tickets/scaled-tickets').then(m => m.ScaledTickets),
        },
        {
            canActivate: [directionGuard],
            path: AppPath.SCALED_TICKETS_WITH_ID,
            loadComponent: () => import('./routes/ticket/ticket-scaled').then(m => m.TicketScaled)
        }
    ]
},
{
    path: '**',
    pathMatch: 'full',
    redirectTo: BasicPath.AUTH
}
];
